
<template>
  <v-form ref="form" v-model="valid" lazy-validation>
    <v-container>
      <h4>Kahve Boyutu Ekle</h4>
      <v-row style="margin-top:100px;">
        <v-col cols="12" md="4">
          <h4>Başlık</h4>
          <v-text-field v-model="coffeeSizeData.coffeeSize" :rules="titleRules" required></v-text-field>
        </v-col>
        <v-col cols="12" md="8"></v-col>

        <v-col cols="12" md="4">
          <h4>Resim</h4>
          <!-- <v-text-field v-model="onBoardingData.imgUrl" :rules="imgUrlRules" required></v-text-field> -->
          <v-file-input
            show-size
            accept="image/*"
            v-model="coffeeSizeData.coffeeSizeImg"
            :rules="fileRules"
            label="Resim yükle"
            required
          ></v-file-input>
        </v-col>
        <v-col cols="12" md="8"></v-col>

        <v-col cols="12" md="4">
          <h4>Seçili Resim</h4>
          <!-- <v-text-field v-model="onBoardingData.imgUrl" :rules="imgUrlRules" required></v-text-field> -->
          <v-file-input
            show-size
            accept="image/*"
            v-model="coffeeSizeData.coffeeSizeImgSelected"
            :rules="fileRules"
            label="Resim yükle"
            required
          ></v-file-input>
        </v-col>
        <v-col cols="12" md="8"></v-col>

        <v-col cols="12" md="4">
          <h4>Aktif/Pasif</h4>
          <v-checkbox v-model="coffeeSizeData.active"></v-checkbox>
        </v-col>
        <v-col cols="12" md="8"></v-col>

        <v-col cols="12" md="7">
          <v-btn
            depressed
            color="primary"
            style="text-transform: none !important;float:right;"
            @click="coffeeSizeAdd()"
          >EKLE</v-btn>
        </v-col>
      </v-row>

      <!-- <v-row>
          
      </v-row>-->
    </v-container>
  </v-form>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "CoffeeSize",
  methods: {
    ...mapActions(["addCoffeeSize"]),
    routeCoffeeSizes() {
      this.$router.push("/dashboard/productCategories/coffeeSizes");
    },
    coffeeSizeAdd() {
      if (this.$refs.form.validate()) {
        this.snackbar = true;

        Promise.all([
        this.getBase64(this.coffeeSizeData.coffeeSizeImg).then(data=>{
         this.coffeeSizeData.coffeeSizeImg = data;
        }),
        this.getBase64(this.coffeeSizeData.coffeeSizeImgSelected).then(data=>{
         this.coffeeSizeData.coffeeSizeImgSelected = data;
        })
        ]).then(()=>{
            console.log("data",this.coffeeSizeData);
                   this.addCoffeeSize(this.coffeeSizeData).then(response=>{
          console.log(response);
          if(response.processStatus == "Success") {
            this.routeCoffeeSizes();
          }
        }); 
        }) 
      }
    },
      getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result.split(',')[1]);
    reader.onerror = error => reject(error);
  });
},
  },
  data: () => ({
    dialog: false,
    valid: true,
    titleRules: [v => !!v || "Başlık alanı zorunludur."],
      fileRules: [
      // value => value.size < 1000 || 'Avatar size should be less than 2 MB!',
      v => !!v || "Resim gereklidir.",
      v => (v && v.name != null) || "Resim gereklidir."
    ],
    coffeeSizeData:{
        coffeeSize:"",
        coffeeSizeImg:[],
        coffeeSizeImgSelected:[],
        active:true
    }
  })
};
</script>
